import { render } from "./DataTableGrid.vue?vue&type=template&id=9517830a&scoped=true"
import script from "./DataTableGrid.vue?vue&type=script&lang=js"
export * from "./DataTableGrid.vue?vue&type=script&lang=js"

import "./DataTableGrid.vue?vue&type=style&index=0&id=9517830a&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9517830a"]])

export default __exports__